<!--
 * @Author: your name
 * @Date: 2021-07-30 11:58:16
<<<<<<< HEAD
<<<<<<< HEAD
 * @LastEditTime: 2022-11-15 17:58:31
=======
 * @LastEditTime: 2022-11-22 10:15:19
>>>>>>> feat-m-20221122
=======
 * @LastEditTime: 2022-11-22 12:31:15
>>>>>>> feat-m-stockAndLogistics-20221122
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting
-->
<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      label-width="140px"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col :span="colSpan">
          <el-form-item :label="$t('settingAuthorize.header.name')" prop="logisticsCompanyName">
            <BjInput
              v-model="queryParams.logisticsCompanyName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('settingAuthorize.header.business')" prop="logisticsBusinessName">
            <BjInput
              v-model="queryParams.logisticsBusinessName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
              clearable
              @keyup.enter.native="handleQuery"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('settingAuthorize.header.type')" prop="interfaceType">
            <BjSelectLov
              v-model="queryParams.interfaceType"
              lov-code="STHI.INTERFACE_TYPE"
            /> </el-form-item
        ></el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('settingAuthorize.header.channel')" prop="channelTypeCode">
            <BjSelectLov
              v-model="queryParams.channelTypeCode"
              lov-code="SCHL.CHANNEL_TYPE"
            /> </el-form-item
        ></el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('settingAuthorize.authorized') }}</el-button>
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="{ row }">
              <template v-if="false" />
              <el-tag
                v-else-if="['autoGetLogisticsNo', 'defaultFlag'].includes(col.prop)"
                :type="row[col.prop] ? 'success' : 'info'"
                >{{ $t(STATUS_YES_TRUE.bjGet(row[col.prop])) }}</el-tag
              >
              <template v-else-if="col.prop === 'warehouseList'">
                {{ row[col.prop] && row[col.prop].map(e => e.warehouseName).join() }}
              </template>
              <template v-else-if="col.prop === 'channelList'">
                {{ row[col.prop] && row[col.prop].map(e => e.channelTypeCodeMeaning).join() }}
              </template>
              <template v-else-if="col.prop === 'printCloudStandardTemplate'">
                {{ row[col.prop].name }}
              </template>
              <template v-else-if="col.prop === 'address'">
                {{ row.province + row.city + row.district + row[col.prop] }}
              </template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="onEdit(row)">{{ $t('editText') }}</el-button>
              <el-button type="text" @click="onDelete(row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { thirdApi } from '@/api';
import DataForm from './components/DataForm.vue';
import { STATUS_YES_TRUE } from '@/utils/constants';
export default {
  name: 'SettingLogisticsStrategyAuthorizeIndex',
  components: { DataForm },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      queryApi: thirdApi.getLogisticsAuthorizes,
      // constants
      STATUS_YES_TRUE,
      // 查询参数
      queryParams: {
        logisticsCompanyName: null,
        logisticsBusinessName: null,
        interfaceType: null,
        channelTypeCode: null,
      },
      labelsVersion: 1,
      labelList: [
        { label: 'settingAuthorize.table.name', prop: 'logisticsCompanyName', isCheck: true, width: '180', disabled: false },
        { label: 'settingAuthorize.table.business', prop: 'logisticsBusinessName', isCheck: true, width: '180', disabled: false },
        { label: 'settingAuthorize.table.type', prop: 'interfaceTypeMeaning', isCheck: true, disabled: false, width: '180' },
        { label: 'settingAuthorize.table.channel', prop: 'channelList', isCheck: true, disabled: false, width: '180' },
        {
          label: 'settingAuthorize.table.obtain',
          prop: 'autoGetLogisticsNo',
          isCheck: true,
          disabled: false,
          width: 180,
        },
        { label: 'settingAuthorize.table.default', prop: 'defaultFlag', isCheck: true, disabled: false, width: 135 },
        { label: 'settingAuthorize.table.warehouse', prop: 'warehouseList', isCheck: true, disabled: false, width: 135 },
        {
          label: 'settingAuthorize.table.template',
          prop: 'printCloudStandardTemplate',
          isCheck: true,
          disabled: false,
          width: 180,
        },
        { label: 'settingAuthorize.table.linkMan', prop: 'sender', isCheck: true, disabled: false, width: 120 },
        { label: 'settingAuthorize.table.phone', prop: 'senderPhone', isCheck: true, disabled: false, width: 120 },
        { label: 'settingAuthorize.table.address', prop: 'address', isCheck: true, disabled: false, width: 180 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 100 },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 创建库存 */
    onAdd() {
      this.$refs.DataForm.show();
    },
    onEdit(row) {
      thirdApi.getLogisticsAuthorizesDetail({ id: row.id }).then(res => {
        this.$refs.DataForm.show(res);
      });
    },
    onDelete(row) {
      this.$MessageBox({ content: this.$t('toast.delAllTipText') }).then(res => {
        this.batchDeleteApi({ idList: [row.id] });
      });
    },
    batchDeleteApi(API_DATA) {
      thirdApi.deleteLogisticsAuthorizes(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.BjImportFileResult {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button {
    margin-left: 10px;
  }
}
</style>
